import React from 'react';
import ModulesPage from './ModulesComponents/ModulesPage';

const ModulesView = (props) => {
  return <ModulesPage {...props} />;
};

export default ModulesView;
